import { render, staticRenderFns } from "./TransferList.vue?vue&type=template&id=e680e4e2"
import script from "./TransferList.vue?vue&type=script&lang=js"
export * from "./TransferList.vue?vue&type=script&lang=js"
import style0 from "./TransferList.vue?vue&type=style&index=0&id=e680e4e2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports